import GQLClient from "../../Config/GraphqlConfig";
import { MutationAddConsumablePrestaArgs, MutationAddProblemArgs, MutationComfirmEventArgs, MutationFinishEventArgs, MutationRemoveAchatDeclarationArgs,  MutationUpdateProblemArgs, Result } from "../type/type";
import { CREATE_BOOKING_REQUEST, ADD_CONSUMABLE, ADD_PROBLEM, COMFIRM_EVENT, FINISH_PROBLEM, MODIFY_PROBLEM, PUSH_TOKEN_NOTIF, REMOVE_ACHAT_DECLARATION, EDIT_FINISHED_EVENT } from "./index.definition";


interface finishedEventEditObject {
    commentary: String;
    validationPicture: ValidationPicturesToAdd[];
};

interface ValidationPicturesToAdd {
    base64: String;
    uri: String;
    shouldRemove: Boolean;
}
export default class Mutation {
    private client = GQLClient.getIntance()?.getClient()

    pushTokenNotif(token: string, bookingId: string, tokenUser: string, lang: string) {
        return this.client
            .mutate<{ pushTokenNotif: Result }>({
                mutation: PUSH_TOKEN_NOTIF,
                variables: {
                    token,
                    bookingId,
                    lang
                },
                context: {
                    headers: {
                        token: tokenUser
                    }
                }
            })
    }

    insertBookingRequest(appartId: string, departureDate: string, arrivalDate: string, reason: string, userToken: string) {
        return this.client
            .mutate<{ insertBookingRequest: Result }>({
                mutation: CREATE_BOOKING_REQUEST,
                variables: {
                    appartId,
                    departureDate,
                    arrivalDate,
                    reason
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
            })
    }

    editFinishedEvent(eventId: string, editObject: finishedEventEditObject, userToken: string) {
        return this.client
            .mutate<{ editFinishedEvent: Result }>({
                mutation: EDIT_FINISHED_EVENT,
                variables: {
                    eventId,
                    editObject
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
            })
    }

    confirmEvent(eventId: string, userToken: string) {
        return this.client
            .mutate<{ confirmEvent: Result },
                MutationComfirmEventArgs
            >(
                {
                    mutation: COMFIRM_EVENT,
                    variables: {
                        eventId
                    },
                    context: {
                        headers: {
                            token: userToken
                        }
                    }
                }
            )
    }

    addConsumablePresta(totalPriceTTC: number, purchaseDate: Date, images: string[], userToken: string, appartId: string){
        return this.client
        .mutate<{ addConsumablePresta: Result},
            MutationAddConsumablePrestaArgs
        >(
            {
                mutation: ADD_CONSUMABLE,
                variables: {
                    totalPriceTTC,
                    images,
                    appartId,
                    purchaseDate
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
           }
        )
    }

    addProblem(eventId: string, title: string, description: string, images: string[], userToken: string) {
        return this.client
        .mutate<{ addProblem: Result},
            MutationAddProblemArgs
        >(
            {
                mutation: ADD_PROBLEM,
                variables: {
                    eventId,
                    title,
                    description,
                    images
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
           }
        )
    }

    updateProblem(eventId: string, title: string, description: string, index: Number, userToken: string) {
        return this.client
        .mutate<{ addProblem: Result},
            MutationUpdateProblemArgs
        >(
            {
                mutation: MODIFY_PROBLEM,
                variables: {
                    eventId,
                    title,
                    description,
                    index
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
           }
        )
    }

    finishEvent(eventId: string, todoList: any, userToken: string, commentary: string, images: string[]) {
        return this.client
        .mutate<{ addProblem: Result},
            MutationFinishEventArgs
        >(
            {
                mutation: FINISH_PROBLEM,
                variables: {
                    eventId,
                    todoList,
                    commentary,
                    images
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
           }
        )
    }

    removeAchatDeclaration(achatId: string, userToken: string) {
        return this.client
        .mutate<{ removeAchatDeclaration: Result},
            MutationRemoveAchatDeclarationArgs
        >(
            {
                mutation: REMOVE_ACHAT_DECLARATION,
                variables: {
                    achatId
                },
                context: {
                    headers: {
                        token: userToken
                    }
                }
           }
        )
    }


}